import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TabsDriverPageRoutingModule } from './tabs-driver.router.module';

import { TabsDriverPage } from './tabs-driver.page';

@NgModule({
  imports: [IonicModule, CommonModule, FormsModule, TabsDriverPageRoutingModule],
  declarations: [TabsDriverPage],
})
export class TabsDriverPageModule {}
